'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _form = require('./form.css');

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsletterForm = function (_Component) {
  _inherits(NewsletterForm, _Component);

  function NewsletterForm() {
    _classCallCheck(this, NewsletterForm);

    var _this2 = _possibleConstructorReturn(this, (NewsletterForm.__proto__ || Object.getPrototypeOf(NewsletterForm)).call(this));

    _this2.state = {
      focusInput: false,
      submitValue: 'submit',
      isSent: false
    };
    return _this2;
  }

  _createClass(NewsletterForm, [{
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({ focusInput: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({ focusInput: false });
    }
  }, {
    key: 'checkForm',
    value: function checkForm(e) {
      e.preventDefault();

      var isSent = this.state.isSent;

      var form = this.refs.form;
      var input = this.refs.input;
      var val = input.value;
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var isEmail = regex.test(val);

      if (!isEmail || isSent) return;

      var action = form.action + '&c=document.MC_callback&EMAIL=' + val;
      console.log(action);
      this.sendInfo(action);
    }
  }, {
    key: 'jsonp',
    value: function jsonp(url, callback, error) {
      var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
      window[callbackName] = function (data) {
        delete window[callbackName];
        document.body.removeChild(script);
        callback(data);
      };

      var script = document.createElement('script');
      script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
      script.onerror = error();
      document.body.appendChild(script);
    }
  }, {
    key: 'sendInfo',
    value: function sendInfo(action) {
      var _this = this;

      document.MC_callback = function (response) {
        if (response.result === 'success') {
          _this.setState({
            submitValue: 'Sent!',
            isSent: true
          });
        } else {
          console.log('An error occured while subscribing to newsletter');
        }
      };

      this._script = document.createElement('script');
      this._script.type = 'text/javascript';
      this._script.src = action;
      document.getElementsByTagName('head')[0].appendChild(this._script);
    }
  }, {
    key: 'render',
    value: function render() {
      var formClass = this.state.focusInput ? _form2.default.formFocus : _form2.default.form;
      var submitValue = this.state.submitValue;


      return _react2.default.createElement(
        'form',
        {
          action: '//soundscapeagency.us14.list-manage.com/subscribe/post-json?u=6b4087fda6127202a074780ae&id=166c205c50',
          method: 'get',
          className: formClass,
          ref: 'form',
          id: 'mc-embedded-subscribe-form'
        },
        _react2.default.createElement('input', {
          className: _form2.default.input,
          type: 'email',
          name: 'EMAIL',
          placeholder: 'Your email address',
          ref: 'input',
          onFocus: this.handleFocus.bind(this),
          onBlur: this.handleBlur.bind(this)
        }),
        _react2.default.createElement('input', { className: _form2.default.submit, type: 'submit', value: submitValue, onClick: this.checkForm.bind(this) })
      );
    }
  }]);

  return NewsletterForm;
}(_react.Component);

exports.default = NewsletterForm;


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsletterForm/NewsletterForm.js
// module id = 148
// module chunks = 1